<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button
          id="minimizeSidebar"
          class="btn btn-icon btn-round"
          aria-label="Minimiser le menu latéral"
          @click.prevent="minimizeSidebar"
        >
          <i
            class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"
          />
          <i
            class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"
          />
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar" />
      </div>
      <a class="navbar-brand" href="#">Gestion de l'Annuaire CIIP</a>
    </div>

    <template slot="navbar-menu">
      <form class="search-form" @submit.prevent="search">
        <div class="input-group no-border">
          <div class="input-group-append">
            <div
              class="input-group-text cursor-displayed"
              @click.prevent="resetSearch"
            >
              <i class="nc-icon nc-simple-remove" />
            </div>
          </div>
          <label for="search" style="display: none">Search</label>
          <input
            v-model="searchField"
            type="text"
            id="search"
            class="form-control"
            placeholder="Recherche..."
          />

          <div class="input-group-append">
            <div
              class="input-group-text cursor-displayed"
              @click.prevent="search"
            >
              <i class="nc-icon nc-zoom-split" />
            </div>
          </div>
        </div>
      </form>
      <ul class="navbar-nav">
        <li v-if="isPowerUserOrAdministrator">
          <p-button
            class="mx-1 my-0 p-2"
            outline
            round
            aria-label="Aller aux configurations des notifications"
            @click.prevent="showUserNotifications"
          >
            Notifications
          </p-button>
        </li>
        <li>
          <el-tooltip
            content="Connexion"
            v-if="!$store.getters['account/token']"
            :open-delay="300"
            placement="bottom"
          >
            <p-button
              class="mx-1 my-0 p-2"
              @click.prevent="window.location = loginUrl"
              outline
              round
              aria-label="Se connecter"
              >Connexion</p-button
            >
          </el-tooltip>
          <el-tooltip
            content="Déconnexion"
            v-else
            :open-delay="300"
            placement="bottom"
          >
            <p-button
              class="mx-1 my-0 p-2"
              @click.prevent="$store.dispatch('account/logout')"
              outline
              round
              aria-label="Déconnexion"
              >Déconnexion</p-button
            >
          </el-tooltip>
        </li>
      </ul>
    </template>
  </navbar>
</template>
<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import { Navbar, NavbarToggleButton } from 'src/components/UIComponents';
import { Tooltip } from 'element-ui';
import EventBus from 'src/event-bus';

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    [Tooltip.name]: Tooltip,
  },
  data() {
    return {
      window,
      searchField: '',
      activeNotifications: false,
      showNavbar: false,
      loginUrl: `${process.env.VUE_APP_LOGIN_URL}?appURL=${window.location.href}`,
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  methods: {
    showUserNotifications() {
      this.$router.push({ name: 'UserNotifications' });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    logout() {
      this.$router.logout();
    },
    search() {
      EventBus.$emit('search', this.searchField);
    },
    resetSearch() {
      EventBus.$emit('search', '');
      this.clearField();
    },
    clearField() {
      this.searchField = '';
    },
  },
};
</script>
<style scope>
.search-form {
  width: 100%;
}
.cursor-displayed {
  cursor: pointer;
}
.profile-button {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
</style>
